import Vue from 'vue';
import he from 'he';

export default {

    configure: () => {

        Vue.filter('decodeHtml', (value) => {

            if (!value) return '';

            return he.decode(value);
        });
    }
}